import React from 'react';

import { Field } from 'formik'
import { TextField } from 'formik-material-ui'

import {
    MenuItem
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    field: {
        width: '100%'
    }
}));

export const Select = (props) => {
    const classes = useStyles();

    return (
        <Field
            select
            className={classes.field}
            name={props.name}
            variant="outlined"            
            InputProps={{
                readOnly: props.isLoading,
            }}
            helperText={props.helperText}
            label={props.label}
            disabled={props.disabled}
            component={TextField}
            {...props}>
            {props.options && props.options.length > 0 &&
                props.options.map((option, index) => {
                    return (
                        <MenuItem key={index} value={option.value}>
                            {option.label !== "@None" ? option.label : <em>None</em>}
                        </MenuItem>
                    );
                })}
        </Field>
    );
}